import React from "react";

// Shared helpers for the automation screens. `api` is App.js's axios
// instance (its baseURL already ends in /api).

export const errorText = (err, fallback) => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg).filter(Boolean).join("; ") || fallback;
  return fallback;
};

export const formatWhen = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toLocaleString();
};

const TONES = {
  Success: "good", succeeded: "good", approved: "good", ok: "good", active: "good",
  Failed: "bad", failed: "bad", rejected: "bad", auto_disabled: "bad",
  Waiting: "warn", pending: "warn", pending_approval: "warn", retry_scheduled: "warn", delivering: "warn", Running: "warn",
  Skipped: "muted", skipped: "muted", Cancelled: "muted", cancelled: "muted", draft: "muted", disabled: "muted",
};

export function StatusPill({ status }) {
  const tone = TONES[status] || "muted";
  const colors = {
    good: ["rgba(16,185,129,.15)", "#34d399"], bad: ["rgba(239,68,68,.15)", "#f87171"],
    warn: ["rgba(245,158,11,.15)", "#fbbf24"], muted: ["rgba(148,163,184,.15)", "#94a3b8"],
  }[tone];
  return (
    <span data-testid={`status-${status}`} style={{ background: colors[0], color: colors[1], borderRadius: 999, padding: "2px 10px", fontSize: 12, whiteSpace: "nowrap" }}>
      {String(status || "").replace(/_/g, " ")}
    </span>
  );
}

export const OPERATOR_LABELS = {
  equals: "equals", not_equals: "does not equal", contains: "contains", not_contains: "does not contain",
  gt: "is greater than", gte: "is at least", lt: "is less than", lte: "is at most",
  in: "is one of (comma separated)", not_in: "is none of (comma separated)", is_empty: "is empty", is_not_empty: "is not empty",
};
export const NO_VALUE_OPS = ["is_empty", "is_not_empty"];
export const LIST_OPS = ["in", "not_in"];

export const LEAD_CONDITION_FIELDS = ["clinic_name", "email", "phone", "city", "state", "status", "pipeline_stage", "lead_source", "priority", "deal_value", "tags", "category", "lead_score", "assigned_team_member_id"];
export const CLIENT_CONDITION_FIELDS = ["clinic_name", "email", "contract_status", "onboarding_status", "monthly_retainer", "portal_activated", "account_manager_id"];

export function conditionFieldSuggestions(eventMeta) {
  return [
    ...(eventMeta?.fields || []).map((f) => `event.${f}`),
    ...LEAD_CONDITION_FIELDS.map((f) => `lead.${f}`),
    ...CLIENT_CONDITION_FIELDS.map((f) => `client.${f}`),
  ];
}
